import { Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import moment from "moment";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { usePclFilesQuery } from "api/public/file/file.api";

import SidebarSection from "../../SidebarSection";

// HACK:
// this is ugly as hell, but this will fix the 5 vids with mismatched vids/pids
// really might want to consider looking at what it would take to update all those records
// if we do that we should remove this
const vidCorrections: Record<string, string> = {
  "11633": "11632",
  "11632": "11631",
  "11631": "11630",
  "11630": "11629",
  "11629": "11628",
};

const ValidationNumberSection = () => {
  const { id } = useParams();
  const { data: files } = usePclFilesQuery(id ?? skipToken);

  const validationReportNumber = useMemo(() => {
    if (!files || !id) return "";

    const validationReport = files.eval_files.find(
      (file) => file.file_display_name === "Validation Report",
    );

    if (!validationReport) return "";
    const yearUploaded = moment(validationReport.uploaded_on).year();

    // Either use the id from the params or transform the 5 mismatched ones
    return `CCEVS-VR-VID${vidCorrections[id] ?? id}-${yearUploaded}`;
  }, [files, id]);

  return (
    <SidebarSection title="Validation Report Number:">
      <Typography variant="body1">{validationReportNumber}</Typography>
    </SidebarSection>
  );
};
export default ValidationNumberSection;
